import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import './assets/cspa.css'
import CUSTOM from '@/custom/customData.js'
import '@/custom/checkLogin.js'
import CKEditor from 'ckeditor4-vue'
import VueMasonry from 'vue-masonry-css'


Vue.use(ViewUI)
Vue.use(VueRouter)
Vue.prototype.GLOBAL_API = CUSTOM
Vue.use(CKEditor)
Vue.use(VueMasonry);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')